import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "../pages/home/page";
import BestAUSCasinos from "../pages/categories/BestAUSCasinos";
import MyTopPicks from "../pages/categories/MyTopPicks";
import BestForGames from "../pages/categories/BestForGames";
import FreeGames from "../pages/categories/FreeGames";
import PlayerReviews from "../pages/categories/PlayerReviews";
import NewGuides from "../pages/categories/NewGuides";
import MethodologyPage from "../pages/methodology/page";
import { ROUTES } from "./routes";

const routes: RouteObject[] = [
  {
    path: ROUTES.home,
    element: <Home />,
  },
  {
    path: ROUTES.topCasinos,
    element: <Home />,
  },
  {
    path: ROUTES.bestAusCasinos,
    element: <BestAUSCasinos />,
  },
  {
    path: ROUTES.myTopPicks,
    element: <MyTopPicks />,
  },
  {
    path: ROUTES.bestForGames,
    element: <BestForGames />,
  },
  {
    path: ROUTES.freeGames,
    element: <FreeGames />,
  },
  {
    path: ROUTES.reviews,
    element: <PlayerReviews />,
  },
  {
    path: ROUTES.newsGuides,
    element: <NewGuides />,
  },
  {
    path: ROUTES.methodology,
    element: <MethodologyPage />,
  },
  {
    path: "*",
    element: <Navigate to={ROUTES.home} replace />,
  },
];

export default routes;